// extracted by mini-css-extract-plugin
export default {"infoContent":"HeaderTitle_infoContent__bIa8S"};